/*
 * File: d:\projects\AutoFiFront\src\Content\IntelBoard\IntelBoardRow.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Friday April 7th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday April 7th 2023 9:07:15 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import translator from 'MultiLanguage/TranslationWrapper';
import styles from 'Content/IntelBoard/IntelBoard.module.css';
import React from 'react';

type IntelBoardRowProps = {
    item: string,
    value: number,
    unit: string,
    index : number
};

function IntelBoardRow(props: IntelBoardRowProps){
    return (
        <React.Fragment>
                <div key={props.item + props.index} className={`${styles.resumePricingItem}`}>
                    <div>
                        {translator.decode(`pricing.${props.item}`)}
                    </div>
                    <div className={`resumePricingItemColor`}>
                        {props.value} {props.unit}
                    </div>
                </div>
        </React.Fragment>
    );
}

export default IntelBoardRow;
